// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Kayıt Firmaları',
  subtitle: 'Domain kayıt firmalarını yönetin',
  newRegistrar: 'Yeni Kayıt Firması',
  addRegistrar: 'Firma Ekle',
  editRegistrar: 'Firma Düzenle',
  registrarName: 'Firma Adı',
  website: 'Website',
  apiKey: 'API Anahtarı',
  apiSecret: 'API Gizli Anahtarı',
  status: 'Durum',
  actions: 'İşlemler',
  noRegistrars: 'Henüz kayıt firması yok',
  noRegistrarsDesc: 'İlk kayıt firmasını ekleyerek başlayın.',
  registrarAdded: 'Domain firması başarıyla eklendi',
  registrarUpdated: 'Domain firması başarıyla güncellendi',
  registrarDeleted: 'Domain firması başarıyla silindi',
  fetchError: 'Domain firmaları alınamadı',
  addError: 'Domain firması eklenemedi',
  updateError: 'Domain firması güncellenemedi',
  deleteError: 'Domain firması silinemedi',
  confirmDelete: 'Bu domain firmasını silmek istediğinizden emin misiniz?',
  statusEnabled: 'Domain firması etkinleştirildi',
  statusDisabled: 'Domain firması devre dışı bırakıldı',
  statusError: 'Domain firması durumu güncellenemedi',
  apiStatus: 'API Durumu',
  apiActive: 'API Aktif',
  apiNone: 'API Yok'
};
